<div class="modal-header">
    <h4 class="modal-title">Vista Upload Details</h4>
</div>
<div class="modal-body">
    <div class="row g-2 mb-2">
        <div class="col-md-6">
            <div class="text-muted small text-uppercase">File Type</div>
            <div>{{ upload.recordType }}</div>
        </div>
        <div class="col-md-6">
            <div class="text-muted small text-uppercase">Status</div>
            <div>
                {{ upload.status }}
                @if (upload.inProgress) {
                    <span class="badge text-bg-info ms-1">In Progress</span>
                }
            </div>
        </div>
        <div class="col-md-6">
            <div class="text-muted small text-uppercase">Started By</div>
            <div>{{ upload.createdByName || '—' }}</div>
        </div>
        <div class="col-md-6">
            <div class="text-muted small text-uppercase">Batch # (accept in Vista)</div>
            <div>{{ upload.batchId || '—' }}</div>
        </div>
        <div class="col-md-6">
            <div class="text-muted small text-uppercase">Rows</div>
            <div>{{ upload.rowCount }}</div>
        </div>
        <div class="col-md-6">
            <div class="text-muted small text-uppercase">File Name</div>
            <div class="text-break">{{ upload.fileName }}</div>
        </div>
        <div class="col-md-4">
            <div class="text-muted small text-uppercase">Created On</div>
            <div>{{ upload.createdOn | date: 'MM/dd/yyyy hh:mm a' }}</div>
        </div>
        <div class="col-md-4">
            <div class="text-muted small text-uppercase">Staged On</div>
            <div>{{ upload.stagedOn ? (upload.stagedOn | date: 'MM/dd/yyyy hh:mm a') : '—' }}</div>
        </div>
        <div class="col-md-4">
            <div class="text-muted small text-uppercase">Completed On</div>
            <div>{{ upload.completedOn ? (upload.completedOn | date: 'MM/dd/yyyy hh:mm a') : '—' }}</div>
        </div>
    </div>

    @if (upload.failureSummary) {
        <div class="alert alert-warning py-2 mb-2">
            <strong>What happened:</strong> {{ upload.failureSummary }}
        </div>
    }

    @if (upload.errorText) {
        <div class="mb-2">
            <div class="text-muted small text-uppercase">Error</div>
            <pre style="white-space: pre-wrap; margin-bottom: 0">{{ upload.errorText }}</pre>
        </div>
    }

    @if (upload.logText) {
        <details>
            <summary>Vista log</summary>
            <pre style="white-space: pre-wrap; margin-top: 8px; margin-bottom: 0">{{ upload.logText }}</pre>
        </details>
    }
</div>
<div class="modal-footer">
    <button id="btnClose" type="button" class="btn btn-secondary" (click)="close()">Close</button>
</div>
